<template>
  <div>
    <Header title="Planos" />
    <Loading v-if="loading_data" />
    <HandleDisplayPlans
      v-else
      :plans="PlanList"
      :kept="EditList"
      @update:kept="updateKept"
    />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import HandleDisplayPlans from "@/handles/paas/plan/HandleDisplayPlans.vue";
import Loading from "@/components/Loading.vue";

//import { createNewPaasPlanDB } from "@/api/db";

import { getPaasPlans, thereArePlansInQueue } from "@/api/paas/plans";

export default {
  name: "PaasHistorico",
  components: {
    Header,
    HandleDisplayPlans,
    Loading
  },
  created() {
    this.$store.commit("setCurrentComponent", {
      component: "Paas"
    });
  },
  data: () => ({
    loading_data: false,
    PlanList: [],
    EditList: []
  }),
  methods: {
    // // CREATE
    // async postNewPlan(plan) {
    //   //Create and save new plan in database
    //   // Verify if plan already is in database
    //   const found = this.PlanList.findIndex(el => {
    //     return el.paas_solution_hash == plan.hash;
    //   });

    //   //If isn't in database
    //   if (this.PlanList.length == 0 || found < 0) {
    //     // Creates plan object
    //     const body = {
    //       idVinculo: plan.user,
    //       hash: plan.hash,
    //       name: plan.nome,
    //       date: plan.date,
    //       numClasses: plan.numClasses,
    //       numRooms: plan.numRooms
    //     };

    //     //save object in database trough db api
    //     const updatedPlanList = await createNewPaasPlanDB(body);
    //     //Update PlanList
    //     this.PlanList = updatedPlanList;
    //   }
    //   // Remove temporary plan from store
    //   this.$store.dispatch("removeFromHistoricoPAAS", plan);
    // },
    updatePlanList() {
      // get array of plans in database through db api
      this.loading_data = true;
      getPaasPlans()
        .then(_ => {
          this.PlanList = _;
        })
        .finally(() => {
          this.loading_data = false;
        });
    },
    verifyIfthereArePlansInQueue(firstRun = true) {
      thereArePlansInQueue()
        .then(_ => {
          if (_) {
            setTimeout(
              this.verifyIfthereArePlansInQueue,
              3000,
              false
            );
            return;
          }
          if (!firstRun) {
            this.updatePlanList();
            return;
          }
        })
        .catch(() => {
          console.log("erro ao verificar planos em fila");
        });
    },
    updateKept() {
      this.EditList = this.$store.getters.getEditSaveList;
    }
  },
  mounted() {
    //Update PlanList
    this.EditList = this.$store.getters.getEditSaveList;
    this.updatePlanList();
    this.verifyIfthereArePlansInQueue();
  }
};
</script>
